"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendoProvider = void 0;
const config_1 = require("@completeanatomy/config");
const agent_1 = require("@pendo/agent");
const typedi_1 = require("typedi");
let PendoProvider = class PendoProvider {
    constructor(config) {
        this.config = config;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiKey = this.config.get('pendoApiKey');
            if (!apiKey) {
                console.warn('Pendo API key is not configured.');
                return;
            }
            const initConfig = {
                apiKey,
                env: 'io',
                cookieDomain: window.location.hostname,
                account: {
                    id: 'ACCOUNT-ANONYMOUS',
                },
            };
            this.pendo = yield (0, agent_1.initialize)(initConfig);
            // this.pendo.enableLogging();
        });
    }
    setAnonymousSession() {
        if (!this.pendo) {
            console.warn('Pendo is not initialized. Call initialize() first.');
            return;
        }
        this.pendo.clearSession();
        const anonymousSessionConfig = {
            account: {
                id: 'ACCOUNT-ANONYMOUS',
            },
        };
        this.pendo.identify(anonymousSessionConfig);
    }
    updateUserSession(user) {
        if (!this.pendo) {
            console.warn('Pendo is not initialized. Call initialize() first.');
            return;
        }
        const userSessionConfig = this.createUserInitObject(user);
        this.pendo.identify(userSessionConfig);
    }
    log(eventName, properties = {}) {
        if (!this.pendo) {
            console.warn('Pendo is not initialized. Call initialize() first.');
            return;
        }
        this.pendo.track(eventName, properties);
    }
    teardown() {
        if (!this.pendo) {
            console.warn('Pendo is not initialized. Call initialize() first.');
            return;
        }
        this.pendo.teardown();
        // @ts-ignore -- temporary workaround, add pendo to window types
        delete window.pendo;
    }
    createUserInitObject(user) {
        return {
            visitor: Object.assign({ id: user.identifier.toString(), full_name: user.name, role: user.kind }, user),
            account: {
                id: user.identifier.toString(),
                organization: user.organization ? user.organization.name : undefined,
            },
        };
    }
};
exports.PendoProvider = PendoProvider;
/**
 * Name of exported module property
 */
PendoProvider.exportName = 'pendoProvider';
exports.PendoProvider = PendoProvider = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [config_1.Config])
], PendoProvider);
